import { useMemo } from 'react';
import PropTypes from 'prop-types';
import Badge from '@mui/material/Badge';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import Stack from '@mui/material/Stack';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';

import { joinString } from 'utils/string';

export const CampaignTableRow = ({ campaign, onClick, selectedCampaign }) => {
	const campaignName = joinString(' - ', [campaign?.campaignName, campaign?.communicationName]);
	const selected = Number(selectedCampaign) === campaign?.id;

	const colorConfigBasedOnRemainingDays = useMemo(() => {
		const percentageLeft = Math.floor((campaign?.daysToEnd / campaign?.daysTotal) * 100);
		if (percentageLeft < 25) {
			return {
				backgroundColor: 'primary.main',
				color: 'common.white',
			};
		} else {
			return { backgroundColor: 'grey.200', color: 'common.black' };
		}
	}, [campaign?.daysToEnd, campaign?.daysTotal]);

	return (
		<TableRow onClick={onClick(campaign?.id)}>
			<TableCell>
				<Stack
					direction="row"
					sx={{
						ml: 1.5,
						alignItems: 'center',
					}}
				>
					<FormControlLabel control={<Radio size="small" checked={selected} />} />
					<Typography variant="body1">{campaignName}</Typography>
				</Stack>
			</TableCell>
			<TableCell align="right">
				<Badge
					showZero
					badgeContent={campaign?.daysToEnd}
					color="success"
					max={100000}
					sx={{
						marginRight: 2,
						'& .MuiBadge-anchorOriginTopRight': {
							...colorConfigBasedOnRemainingDays,
						},
					}}
				/>
			</TableCell>
		</TableRow>
	);
};

CampaignTableRow.propTypes = {
	campaign: PropTypes.number,
	onClick: PropTypes.func,
	selectedCampaign: PropTypes.number,
};

export default CampaignTableRow;
